export enum Application {
	SMARTY_FIN = 'SMARTY-FIN',
	SMARTY_CUBE = 'SMARTY-CUBE',
	SMARTY_360 = 'SMARTY-360',
}
